import script from "./QuizTile.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizTile.vue?vue&type=script&setup=true&lang=js"

import "./QuizTile.vue?vue&type=style&index=0&id=12afa2ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12afa2ee"]])

export default __exports__